<div class="row">
  <div *ngIf="!controlIsDisabled('PayTypeCD')" class="col-12 col-md-6 col-lg-4">
    <div class="mb-3">
      <label class="form-label" for="payType">
        Pay Type
        <span *ngIf="controlIsRequired('PayTypeCD')" class="color-error"
          >*</span
        >
      </label>
      <select
        id="payType"
        class="form-select"
        aria-label="Payment type dropdown menu."
        [formControl]="getFormControl('PayTypeCD')"
        (change)="onChange($event)"
      >
        <option selected value="">Select pay type.</option>
        <option *ngFor="let item of payTypes" [value]="item.Value">
          {{ item.Text }}
        </option>
      </select>
    </div>
  </div>
  <div *ngIf="!controlIsDisabled('PayPeriod')" class="col-12 col-md-6 col-lg-4">
    <div class="mb-3">
      <label class="form-label" for="payPeriod">
        Pay Periods
        <span *ngIf="controlIsRequired('PayPeriod')" class="color-error"
          >*</span
        >
      </label>
      <select
        id="payPeriod"
        class="form-select"
        aria-label="Payment period dropdown menu."
        [formControl]="getFormControl('PayPeriod')"
      >
        <option selected value="">Select pay period.</option>
        <option *ngFor="let item of payPeriods" [value]="item.Value">
          {{ item.Text }}
        </option>
      </select>
    </div>
  </div>
</div>
<div class="row">
  <div
    *ngIf="!controlIsDisabled('TakeHomePay')"
    class="col-12 col-md-6 col-lg-4"
  >
    <div class="mb-3">
      <label class="form-label" for="takeHomePay">
        Take Home Pay Per Month
        <span *ngIf="controlIsRequired('TakeHomePay')" class="color-error"
          >*</span
        >
      </label>
      <div class="input-group mb-3">
        <span class="input-group-text">$</span>
        <input
          class="form-control"
          id="takeHomePay"
          placeholder="Amount"
          type="number"
          min="0"
          step="1000"
          [formControl]="getFormControl('TakeHomePay')"
          aria-label="Amount per paycheck (to the nearest dollar)"
        />
      </div>
    </div>
  </div>
  <div
    *ngIf="!controlIsDisabled('NetIncomePPP')"
    class="col-12 col-md-6 col-lg-4"
  >
    <div class="mb-3">
      <label class="form-label" for="netMonthlyIncome">
        Net Monthly Income
        <span *ngIf="controlIsRequired('NetIncomePPP')" class="color-error"
          >*</span
        >
      </label>
      <div class="input-group mb-3">
        <span class="input-group-text">$</span>
        <input
          class="form-control"
          id="netMonthlyIncome"
          placeholder="Amount"
          type="number"
          min="0"
          step="1000"
          [formControl]="getFormControl('NetIncomePPP')"
          aria-label="Net monthly income (to the nearest dollar)"
        />
      </div>
    </div>
  </div>
  <div
    *ngIf="!controlIsDisabled('HourlyRate')"
    class="col-12 col-md-6 col-lg-4"
  >
    <div class="mb-3">
      <label class="form-label" for="hourlyRate">
        Hourly Rate
        <span *ngIf="controlIsRequired('HourlyRate')" class="color-error"
          >*</span
        >
      </label>
      <div class="input-group mb-3">
        <span class="input-group-text">$</span>
        <input
          class="form-control"
          id="hourlyRate"
          placeholder="Amount"
          type="number"
          min="0"
          step="1"
          [formControl]="getFormControl('HourlyRate')"
          aria-label="Hourly rate (to the nearest dollar)"
        />
      </div>
    </div>
  </div>
  <div
    *ngIf="!controlIsDisabled('HoursPerWeek')"
    class="col-6 col-md-4 col-lg-3"
  >
    <div class="mb-3">
      <label class="form-label" for="hoursPerWeek">
        Hours Per Week
        <span *ngIf="controlIsRequired('HoursPerWeek')" class="color-error"
          >*</span
        >
      </label>
      <input
        class="form-control"
        id="hoursPerWeek"
        placeholder="Hours"
        type="number"
        min="0"
        step="1"
        [formControl]="getFormControl('HoursPerWeek')"
        aria-label="Hours per week"
      />
    </div>
  </div>
  <div
    *ngIf="!controlIsDisabled('AnnualSalary')"
    class="col-12 col-md-6 col-lg-4"
  >
    <div class="mb-3">
      <label class="form-label" for="annualSalary">
        Annual Salary
        <span *ngIf="controlIsRequired('AnnualSalary')" class="color-error"
          >*</span
        >
      </label>
      <div class="input-group mb-3">
        <span class="input-group-text">$</span>
        <input
          class="form-control"
          id="annualSalary"
          placeholder="Amount"
          type="number"
          min="0"
          step="1000"
          [formControl]="getFormControl('AnnualSalary')"
          aria-label="Annual salary (to the nearest dollar)"
        />
      </div>
    </div>
  </div>
</div>
